/** BE caches scheduled-drop widget data (~30 min); aligns FE query staleTime. */
export const SCHEDULED_DROP_WIDGET_REFRESH_MS = 30 * 60 * 1000;
